import { Modal, Tooltip } from 'antd';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { NewConsumerForm } from '@form/new-consumer/new-consumer.form';

import { useNewConsumer } from './new-consumer.hook';
import {
  ConsumerButtonTitle,
  ConsumerIcon,
  FooterWrapper,
  FormWrapper,
  NewConsumerWrapper,
} from './new-consumer.style';

export const NewConsumer = () => {
  const { form, isLoading, isModalOpen, shouldEdit, onOpenModal, onCloseModal, onFinish } = useNewConsumer();

  return (
    <>
      <NewConsumerWrapper>
        <Tooltip
          color={ColorEnum.Error100}
          placement='top'
          title={
            shouldEdit ? (
              ''
            ) : (
              <Text color={ColorEnum.Inherit} level='s'>
                You don&apos;t have permission
              </Text>
            )
          }
        >
          <Button
            disabled={!shouldEdit}
            icon={<ConsumerIcon />}
            loading={isLoading}
            size='small'
            type={ButtonTypeEnum.Primary}
            block
            ghost
            onClick={onOpenModal}
          >
            <ConsumerButtonTitle>Set up a new Consumer</ConsumerButtonTitle>
          </Button>
        </Tooltip>
      </NewConsumerWrapper>
      <Modal
        confirmLoading={isLoading}
        open={isModalOpen}
        title='Set up a new Consumer'
        footer={
          <FooterWrapper>
            <Button key='back' type={ButtonTypeEnum.Primary} ghost onClick={onCloseModal}>
              <ConsumerButtonTitle>Cancel</ConsumerButtonTitle>
            </Button>
            <Button
              key='submit'
              loading={isLoading}
              type={ButtonTypeEnum.Primary}
              onClick={() => form.validateFields().then(onFinish)}
            >
              Create
            </Button>
          </FooterWrapper>
        }
        centered
        onCancel={onCloseModal}
        onOk={() => form.validateFields().then(onFinish)}
      >
        <FormWrapper>
          <NewConsumerForm form={form} />
        </FormWrapper>
      </Modal>
    </>
  );
};
